import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import {fetchUserTimelines, resetUserTimelines} from '../../../../creators/user.timelines';
import {fetchCurrentUser} from "../../../../creators/currentUser";
import {fetchUser, resetUser} from "../../../../creators/user";

import PublishStatus from '../../../components/timeline/components/PublishStatus';
import CardStatus from '../../../components/timeline/components/CardStatus';
import ArticleStatus from '../../../components/timeline/components/ArticleStatus';
import MosaicStatus from '../../../components/timeline/components/MosaicStatus';
import {SpinLoader} from '../../../components/Loader';
import InfiniteScroll from "react-infinite-scroll-component";
import TopicStatus from "../../../components/timeline/components/TopicStatus";
//import Advertising from "../../../components/Advertising/Advertising";

class TimelineActu extends React.Component {
    constructor(props) {
        super(props);
        this.privateFeed = !!props.privateFeed
        this.state = {
            filter: {
                limit: 8,
                dateIndex: null
            }
        };
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        this.props.resetUserTimelines();
        if (this.props.currentUser && this.props.currentUser._id && (this.props.currentUser._id !== this.props.userId) && this.props.user._id !== this.props.userId) {
            this.props.fetchUser(this.props.userId);
        } else if (this.props.currentUser && this.props.currentUser._id) {
            this.props.fetchCurrentUser();
        }
        this.fetchUserTimelines(this.state.filter, true);
    }

    componentWillUnmount() {
        this.props.resetUserTimelines();
    }

    fetchUserTimelines(filter, more) {
        filter = {...filter};
        this.props.fetchUserTimelines(this.props.userId, filter, more, this.privateFeed)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.userId !== this.props.userId) {
            this.setState({
                filter: {...this.state.filter}
            });
            this.props.resetUserTimelines();
            if (this.props.userId) {
                this.fetchUserTimelines({...this.state.filter}, false);
            }
        }

        // if (prevProps.currentUser._id !== this.props.currentUser._id && prevProps.userId === this.props.userId) {
        //     this.setState({
        //         currentUser: this.props.userId,
        //         filter: {...this.state.filter, page: 1}
        //     });
        //     this.props.resetUserTimelines();
        //     if (this.props.currentUser && this.props.currentUser._id) {
        //         this.fetchUserTimelines({...this.state.filter}, false);
        //     }
        // }
    }

    handleScroll() {
        // let page = this.state.filter.page + 1;
        let newFilter = {...this.state.filter, dateIndex: this.props.timelinesLastDateIndex};
        this.setState({filter: newFilter});
        this.fetchUserTimelines(newFilter, true);
    }

    // shouldComponentUpdate(nextProps, nextState, nextContext) {
    //     if(this.props.currentUser !== nextProps.currentUser){
    //         return true;
    //     }
    //     if(this.props.userId !== nextProps.userId){
    //         return true;
    //     }
    //     if(this.props.timelines !== nextProps.timelines){
    //         return true;
    //     }
    //     if(this.props.timelinesTotal !== nextProps.timelinesTotal){
    //         return true;
    //     }
    //     if(this.props.timelinesLoading !== nextProps.timelinesLoading){
    //         return true;
    //     }
    //     if(this.props.timelinesInitialized !== nextProps.timelinesInitialized){
    //         return true;
    //     }
    //     if(this.props.currentUserInitialized !== nextProps.currentUserInitialized){
    //         return true;
    //     }
    //     if(this.props.userInitialized !== nextProps.userInitialized){
    //         return true;
    //     }
    //     return this.state !== nextState;
    // }

    render() {
        let allowedToComment = this.props.isMe ? this.props.currentUser.setting.comment.allowed : this.props.user.setting.comment.allowed;
        let timeline = [...this.props.timelines];
        let user = this.state.userIsMe ? this.props.currentUser : this.props.user;
        return (
            <div id="timeline-actu">
                <div className="actu-loaded">
                    {(allowedToComment || this.props.isMe) && user.role !== "banned" ? (
                        <PublishStatus {...this.props}/>
                    ) : (
                    <div className={"no-content mb-16"}>
                        Vous ne pouvez pas publier de commentaire sur ce mur
                    </div>
                    )}
                    {!this.props.timelinesLoading && this.props.timelinesError && this.props.timelinesTotal === 0 && (
                        <div className="no-content column my-8">
                            <span>Aucun contenu à afficher sur cette page.</span>
                        </div>
                    )}
                    {this.props.timelinesInitialized && this.props.timelinesTotal !== 0  && (
                        <InfiniteScroll
                            dataLength={timeline.length} //This is important field to render the next data
                            next={this.handleScroll}
                            hasMore={timeline.length !== this.props.timelinesTotal}
                            loader={<SpinLoader key={this.state.filter.page} />}
                            endMessage={
                                <span className={"no-more-content"}>
                                Aucun contenu supplémentaire à afficher
                            </span>
                            }
                        >
                            {timeline.map((item) => {
                                if (item.parentKind === "Status" && item.parentId !== null) {
                                    return <CardStatus key={item.parentId._id} {...item}/>
                                } else if ((item.parentKind === "Article") && item.parentId !== null) {
                                    return <ArticleStatus key={item.parentId._id} {...item} />
                                } else if (item.parentKind === "Media" && item.parentId !== null) {
                                    return <MosaicStatus key={item.parentId._id} {...item} />
                                } else if (item.parentKind === "Topic" && item.parentId !== null){
                                    return <TopicStatus key={item.parentId._id} {...item} />
                                } else return null;
                            })}
                        </InfiniteScroll>
                    )}
                </div>
                {!this.props.timelinesLoading && this.props.timelinesError && (this.props.timelinesError.status === "400" || this.props.timelinesError.status === "500") && (
                    <div className="warning my-8">Impossible de charger le fil d'actualités</div>)}
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        timelines: state.userTimelines.data,
        timelinesError: state.userTimelines.error,
        timelinesLoading: state.userTimelines.loading,
        timelinesLastDateIndex: state.userTimelines.lastDateIndex,
        userStatusSubmitting: state.userTimelines.submitting,
        timelinesInitialized: state.userTimelines.initialized,
        timelinesTotal: state.userTimelines.total,
        timelinesMore: state.userTimelines.more,

        article: state.article.data,

        currentUserInitialized: state.currentUser.initialized,

        user: state.user.data,
        userInitialized: state.user.initialized
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserTimelines,
    resetUserTimelines,
    fetchCurrentUser,
    fetchUser,
    resetUser,
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(TimelineActu);
